import { IFormControl } from "@/types"
import { cn } from "@/utils"
import { InputHTMLAttributes, ReactNode } from "react"
import { Controller, FieldValues } from "react-hook-form"
import { useIntl } from "react-intl"
import "./style.sass"

interface ICheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: ReactNode
  error?: string
  type?: "checkbox" | "radio"
}

export const Checkbox = ({ label, type = "checkbox", error, className, ...props }: ICheckboxProps) => {
  const inputType = ["checkbox", "radio"].includes(type) ? type : "checkbox"
  return (
    <label className={cn("custom-checkbox", className)}>
      <input type={inputType} {...props} />
      <span className="text-sm">{label}</span>
      {error != null && <span>{error}</span>}
    </label>
  )
}

type IFormCheckboxProps<T extends FieldValues> = IFormControl<T> & ICheckboxProps
export const FormCheckbox = <T extends FieldValues>({ control, required, name, rules, error, ...props }: IFormCheckboxProps<T>) => {
  const { $t: t } = useIntl()
  return (
    <Controller
      {...{
        control,
        name,
        rules: {
          ...rules,
          required: { value: required ?? false, message: t({ id: "required" }) },
        },
      }}
      render={({ field, fieldState: { error } }) => <Checkbox {...props} checked={field.value} {...field} error={error?.message} />}
    />
  )
}
